import client from './client';
import type {
  DORAMetrics,
  ProductivityMetrics,
  BusinessMetrics,
  MetricsOverview,
  MetricTrend,
} from '@/types';

export async function fetchDORAMetrics(periodDays: number = 30) {
  const { data } = await client.get<DORAMetrics>('/metrics/dora', {
    params: { period_days: periodDays },
  });
  return data;
}

export async function fetchProductivityMetrics(periodDays: number = 30) {
  const { data } = await client.get<ProductivityMetrics>('/metrics/productivity', {
    params: { period_days: periodDays },
  });
  return data;
}

export async function fetchBusinessMetrics(periodDays: number = 30) {
  const { data } = await client.get<BusinessMetrics>('/metrics/business', {
    params: { period_days: periodDays },
  });
  return data;
}

export async function fetchMetricsOverview(periodDays: number = 30) {
  const { data } = await client.get<MetricsOverview>('/metrics/overview', {
    params: { period_days: periodDays },
  });
  return data;
}

export async function fetchMetricTrend(
  category: string,
  metricName: string,
  periods: number = 6,
  granularity: string = 'monthly',
) {
  const { data } = await client.get<MetricTrend>('/metrics/trends', {
    params: { category, metric_name: metricName, periods, granularity },
  });
  return data;
}
